// extracted by mini-css-extract-plugin
export var container = "_n5-0";
export var dotAnimation = "_n5-2";
export var dotsLoading = "_n5-1";